import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetEmployees = async (params: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/employees`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load employees.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetAvailableEmployees = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/employees/available`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load available employees.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateEmployee = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/employees/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create employee.",
      errors: error?.response?.data?.errors,
      error: {
        code: error?.response?.status || 400,
        type: "validation",
        errors: error?.response?.data?.errors,
      },
    };
  }
};

export const UpdateEmployee = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/employees/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update employee.",
      errors: error?.response?.data?.errors,
      error: {
        code: error?.response?.status || 400,
        type: "validation",
        errors: error?.response?.data?.errors,
      },
    };
  }
};

export const ToggleEmployeeStatus = async (
  id: number | string,
  status: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/employees/status`, {
      id,
      status,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to change status.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const GetUnlinkedEmployees = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/employees/unlinked`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load unlinked employees.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
